/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrackets = createReactComponent("brackets", "IconBrackets", [
  ["path", { d: "M8 4h-3v16h3", key: "svg-0" }],
  ["path", { d: "M16 4h3v16h-3", key: "svg-1" }]
]);

export { IconBrackets as default };
//# sourceMappingURL=IconBrackets.js.map
